export const allowSomeCommandsToEditCustomVars = (editor) => {
  editor.on("BeforeExecCommand", (e) => {
    if (["FontSize", "mceApplyTextcolor"].includes(e.command)) {
      $(editor.getBody()).find(".custom-var").attr("contenteditable", null);
    }
  });
  editor.on("ExecCommand", () => {
    $(editor.getBody()).find(".custom-var").attr("contenteditable", false);
  });
};
